import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFolder } from '@fortawesome/pro-duotone-svg-icons/faFolder'
import LoadingDefault from '@/Components/Elements/Loading/LoadingDefault'
import AppDialog from '@/Components/AppDialog/AppDialog'
import {
    ContentDossierArchiveProps,
    ContentDossierArchiveState,
} from '../types'
import {
    StyledButton,
    ToolbarButton,
} from '@/Components/Elements/StyledComponents/Buttons'
class ContentDossierArchive extends React.Component<
    ContentDossierArchiveProps,
    ContentDossierArchiveState
> {
    constructor(props: ContentDossierArchiveProps) {
        super(props)

        this.state = {
            showModal: false,
        }

        this.archive = this.archive.bind(this)
        this.dearchive = this.dearchive.bind(this)
    }

    archive() {
        const url =
            this.props.kedo.api().getContentDossierEndpoint() +
            '/' +
            this.props.dossier.id +
            '/archive'
        this.setState({ archiving: true })
        this.props.kedo
            .api()
            .get(url)
            .then((response: any) => {
                const dossier = this.props.dossier
                dossier.archived = true
                this.setState({
                    dossier: dossier,
                    archiving: false,
                    showModal: false,
                })
            })
    }

    dearchive() {
        const url =
            this.props.kedo.api().getContentDossierEndpoint() +
            '/' +
            this.props.dossier.id +
            '/dearchive'
        this.setState({ archiving: true })
        this.props.kedo
            .api()
            .get(url)
            .then((response: any) => {
                const dossier = this.props.dossier
                dossier.archived = false
                this.setState({ dossier: dossier, archiving: false })
            })
    }

    render() {
        return (
            <>
                <AppDialog
                    aria-labelledby="contained-modal-title-vcenter"
                    open={this.state.showModal}
                    maxWidth={'sm'}
                    fullWidth
                    title={this.props.kedo.t('Archive')}
                    onClose={() => this.setState({ showModal: false })}
                    headerClose={() => this.setState({ showModal: false })}
                    contentProps={{ dividers: true }}
                    actions={
                        <>
                            <StyledButton onClick={this.archive}>
                                {this.state.archiving === true ? (
                                    <LoadingDefault as={'span'} size={'sm'} />
                                ) : (
                                    <>
                                        <FontAwesomeIcon icon={faFolder} />{' '}
                                        &nbsp;
                                        {this.props.kedo.t('Archive')}
                                    </>
                                )}
                            </StyledButton>
                            <StyledButton
                                onClick={() =>
                                    this.setState({ showModal: false })
                                }
                                color={'secondary'}
                            >
                                {this.props.kedo.t('Cancel')}
                            </StyledButton>
                        </>
                    }
                >
                    <p>{this.props.kedo.t('confirm_archive')}</p>
                </AppDialog>
                {this.props.dossier.archived === true ? (
                    <ToolbarButton
                        onClick={this.dearchive}
                        variant="contained"
                        title="De-archiveren"
                    >
                        {this.state.archiving === true ? (
                            <LoadingDefault as={'span'} size={'sm'} />
                        ) : (
                            <FontAwesomeIcon icon={faFolder} />
                        )}
                    </ToolbarButton>
                ) : (
                    <ToolbarButton
                        dense={this.props.size === 'sm'}
                        variant="outlined"
                        onClick={() => this.setState({ showModal: true })}
                        title="Archiveren"
                    >
                        <FontAwesomeIcon icon={faFolder} />
                    </ToolbarButton>
                )}
            </>
        )
    }
}

export default ContentDossierArchive
